import { Button, DialogActions, DialogContent } from "@material-ui/core";
import React from "react";

import { DialogTitle, Dialog } from "../../../../../components/Dialog";
import UploadFile from "../../../../../components/UploadFile";

export default function({ open, fundingRequestId, handleClose }) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle onClose={handleClose}>Add Attachments</DialogTitle>
      <DialogContent>
        <UploadFile
          type="funding"
          requestId={fundingRequestId}
          categoriesProps={[
            "Signed Bill of Lading (Delivered)",
            "Signed Bill of Lading (Pick-Up)",
            "Rate Confirmation",
            "Truck Order Not Used",
            "Invoice",
            "Freight Bill",
            "Lumper Receipt",
            "Detention Receipt",
            "Late Fee Receipt",
            "Other"
          ]}
          defaultCategoryValue="Other"
          visibleTo
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
